import React from 'react';
import '../FieldSample.scss';
import { Button } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import { fieldSampleGroupEditor, slopeConversion, truncateFourDecimals } from 'src/store/common';
import { useStoreContext } from 'src/store/context';
import ExpandableText from 'src/shared/ExpandableText/ExpandableText';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import { Grid } from 'src/shared/grid';

/**
 * This will show the station meta data content of the accordion 
 * after user clicks on station meta data
 * 
 */
type SiteMetaProps = {
  fromFieldSample: boolean;
  site:any;
  handleOpenSiteModal?: any
};

export const SiteMetaData: React.FC<SiteMetaProps> = ({ fromFieldSample, site, handleOpenSiteModal }) => {
  const [state] = useStoreContext();
  const convertedLat: number = Number((site.latitude));
  const convertedLong: number = Number((site.longitude));

  return (
    site && <div className='meta-table-container' style={{  height: 'auto', display: 'block', overflow:'auto', width: '100%', padding: '.25rem' }}>
      <div>

      <div style={fromFieldSample? ({ height: '100%', width: '90%', float:'left'}):({ padding: '10px',height: '100px', width: '95vw'})} >

        <Grid row gap="md" style={{ fontWeight: '700'}}>
          <Grid desktop={{col:1}}>LATITUDE</Grid>
          <Grid desktop={{col:1}}>LONGITUDE</Grid>
          <Grid desktop={{col:1}}>ELEVATION</Grid>
          <Grid desktop={{col:3}}>REMARKS</Grid>
          <Grid desktop={{col:3}}>AGENCY LANDOWNER</Grid>
          <Grid desktop={{col:1}}>ASPECT</Grid>
        </Grid>
        <Grid row gap="md" style={{paddingBottom: '10px'}}>
          <Grid desktop={{col:1}}>{truncateFourDecimals(convertedLat)}</Grid>
          <Grid desktop={{col:1}}>{truncateFourDecimals(convertedLong)}</Grid>
          <Grid desktop={{col:1}}>{site.elevation} ft</Grid>
          <Grid desktop={{col:3}}>{(site?.remarks && site?.remarks.length <1? (<>{site.remarks}</>):(
            site?.remarks && 
            <ExpandableText text = {site.remarks} maxWords={3} fontSize="14px"/>
          ))}</Grid>
          <Grid desktop={{col:3}}>{site.jurisdiction}</Grid>
          <Grid desktop={{col:1}}>{site.aspect}</Grid>
        </Grid>
        <Grid row gap="md" style={{ fontWeight: '700' }}>
          <Grid desktop={{col:2}}>CREATED DATE</Grid>
          <Grid desktop={{col:2}}>AREA NAME</Grid>
          <Grid desktop={{col:2}}>GROUP NAME</Grid>
          <Grid desktop={{col:1}}>STATE</Grid>
          <Grid desktop={{col:1}}>STATUS</Grid>
          <Grid desktop={{col:1}}>SLOPE</Grid>
          <Grid desktop={{col:3}}>SAMPLE DATES</Grid>
        </Grid>
        <Grid row gap="md">
          <Grid desktop={{col:2}}>{site.siteStartDate? moment.utc(site.siteStartDate).format('MM/DD/YYYY') : ''}</Grid>
          <Grid desktop={{col:2}}>{site.areaName}</Grid>
          <Grid desktop={{col:2}}>{site.groupName}</Grid>
          <Grid desktop={{col:1}}>{site.stateName}</Grid>
          <Grid desktop={{col:1}}>{site.siteStatus}</Grid>
          <Grid desktop={{col:1}}>{site.slope? slopeConversion(site.slope):''}</Grid>
          <Grid desktop={{col:3}}>{site.fuelSampleMetadata?.firstSampleDate? 
          moment.tz(site.fuelSampleMetadata.firstSampleDate, state.userTimeZone.id[0]).format('MM/DD/YYYY'):''}{site.fuelSampleMetadata?.latestSampleDate?' - ' + 
          moment.tz(site.fuelSampleMetadata.latestSampleDate,state.userTimeZone.id[0]).format('MM/DD/YYYY'):''}</Grid>
        </Grid>
      </div>
      {state.user && (fieldSampleGroupEditor(state.user))
        && fromFieldSample && 
        (
          <div style={{height:'100px'}}>
            <Tooltip title="Edit Site" placement="top-start">
              <span>
                <Button onClick={()=>handleOpenSiteModal(site.siteId)} variant="outlined" style={{ backgroundColor: 'white', paddingTop: '7px', textTransform: 'none'}}><EditIcon fontSize='small' />Edit Site</Button>
              </span>
            </Tooltip>
          </div>
        )
      }
      </div>
    </div>
  );
};